import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, TruckIcon, CreditCardIcon } from 'lucide-react';
import { packColors, packContents } from '../data/copy';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section className="relative w-full scroll-mt-16 bg-abyss py-12 sm:py-24" aria-labelledby="pack-title" id="pack" data-id="element-86" data-mp="1mmqze89blrqt">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-87" data-mp="tylbxdqvtona">
        <div className="grid items-stretch gap-0 border-2 border-chartreuse/60 bg-steel lg:grid-cols-2" data-id="element-88" data-mp="tz3j35f31n9z">
          <div className="relative h-60 overflow-hidden border-b-2 border-chartreuse/40 sm:h-auto sm:min-h-[340px] lg:border-b-0 lg:border-r-2" data-id="element-89" data-mp="p1la5f12f81z">
            <img src="https://cdn.magicpatterns.com/uploads/5edz4esTMMoHMBu1fVVUet/pack_de_30_senuelos.png" alt="Bolsa resellable con el Pack de 30 señuelos Charly Baits sobre una mesa de madera" className="h-full w-full bg-abyss object-contain object-center" data-id="element-90" data-mp="yxerdbpqbpq3" />
            <span className="absolute right-3 top-3 bg-blood px-3 py-1.5 font-display text-xs uppercase tracking-widest text-bone sm:right-4 sm:top-4 sm:px-4 sm:py-2 sm:text-sm" data-id="element-91" data-mp="pj5sehrdw6au">
              Lote limitado
            </span>
          </div>

          <div className="p-5 sm:p-10" data-id="element-92" data-mp="zgafcjt205sp">
            <p className="font-cond text-xs uppercase tracking-[0.28em] text-chartreuse sm:text-sm" data-id="element-93" data-mp="13ki6soqwbzum">
              La oferta
            </p>
            <h2 id="pack-title" className="mt-2 font-display text-2xl uppercase leading-[0.95] text-bone sm:mt-3 sm:text-4xl" data-id="element-94" data-mp="6vai57uzdamh">
              Pack Pro-Series
              <span className="block text-chartreuse" data-id="element-95" data-mp="fsukyl8hrez7">30 piezas</span>
            </h2>

            <p className="mt-4 font-body text-[0.95rem] leading-relaxed text-bone/75 sm:mt-5 sm:text-base" data-id="element-96" data-mp="klxjl7s4lem9">
              Es el arsenal completo: los tres modelos que arman el día
              —Pitbull, Senko y Cangrejo— en las combinaciones de color que
              sacan trofeo a mediodía, en agua turbia y en cristal. Treinta
              piezas. Una sola lobina de 5 libras te lo paga en recuerdo.
            </p>

            <ul className="mt-5 space-y-2 sm:mt-7 sm:space-y-2.5" data-id="element-97" data-mp="qejpa30vidlj">
              {packContents.map(item => <li key={item} className="flex items-start gap-2.5 font-body text-[0.9rem] text-bone/85 sm:gap-3 sm:text-base" data-id="element-98" data-mp="157d3ll4esnom">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-chartreuse" aria-hidden="true" data-id="element-99" data-mp="ch4sgd8aj3jj" />
                  {item}
                </li>)}
            </ul>

            <p className="mt-5 font-cond text-xs uppercase tracking-[0.28em] text-bone/60 sm:text-sm" data-id="element-100" data-mp="hg7oj86alzfd">
              Colores
            </p>
            <ul className="mt-2 flex flex-wrap gap-2" data-id="element-101" data-mp="1wvf0b6ehntoa">
              {packColors.map(color => <li key={color} className="border border-bone/20 px-2.5 py-1 font-cond text-[0.8rem] uppercase tracking-wide text-bone/85 sm:text-sm" data-id="element-102" data-mp="1sul9a45r1yr6">
                  {color}
                </li>)}
            </ul>

            <div className="mt-6 flex flex-wrap items-end gap-x-4 gap-y-1 border-t-2 border-bone/10 pt-5 sm:mt-8 sm:gap-x-5 sm:gap-y-2 sm:pt-7" data-id="element-103" data-mp="1qhj3mzna6ti3">
              <span className="font-cond text-lg uppercase text-ash line-through sm:text-xl" data-id="element-104" data-mp="1vhdux4ayxl3o">
                $750 suelto
              </span>
              <motion.span initial={{
              opacity: 0,
              scale: 0.94
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4
            }} className="font-display text-[2.75rem] leading-none text-chartreuse sm:text-6xl" data-id="element-105" data-mp="2o4htorjgx370">
                $399
              </motion.span>
              <span className="font-cond text-base uppercase text-bone/70 sm:text-lg" data-id="element-106" data-mp="36v9c0ilfo3xj">
                MXN · $13.30 por pieza
              </span>
            </div>

            <div className="mt-4 flex flex-wrap items-center gap-3 font-cond text-xs uppercase text-bone/60 sm:mt-5 sm:text-sm" data-id="element-107" data-mp="1j41ovnng7iao">
              <span className="flex items-center gap-1.5" data-id="element-108" data-mp="197owct3n3ahi">
                <CreditCardIcon className="h-4 w-4" data-id="element-109" data-mp="19ab4atufzs09" />
                Tarjetas
              </span>
              <span className="flex items-center gap-1.5" data-id="element-110" data-mp="14b8a64g03672">
                <span className="font-display text-xs tracking-wider" data-id="element-111" data-mp="21vuh3fup0zhc">OXXO</span>
              </span>
              <span className="flex items-center gap-1.5" data-id="element-112" data-mp="1wyudrcp8aatx">
                SPEI
              </span>
              <span className="text-chartreuse/80" data-id="element-113" data-mp="1s6190otrf2hu">Pago 100% seguro</span>
            </div>

            <CtaButton size="md" source="pack" className="mt-5 w-full sm:hidden" data-id="element-114" data-mp="1n6ycxtvrc6m0">
              ¡Quiero pescar más ya!
            </CtaButton>
            <CtaButton source="pack" className="mt-7 hidden w-full sm:inline-flex" data-id="element-115" data-mp="2kpglt3z8fv3x">
              ¡Quiero pescar más ya!
            </CtaButton>

            <p className="mt-3 flex items-start gap-2 font-body text-xs text-bone/60 sm:mt-4 sm:text-sm" data-id="element-116" data-mp="2o62x4ekh5cnc">
              <TruckIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-117" data-mp="2s64s64vpf7tn" />
              Enviamos a todo México. Sale del taller en 24 horas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}